import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgUser from '../../svg/user.svg'
import { IconProps } from '../icon-props'

const UserIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgUser
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-user', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default UserIcon
